import axios from 'axios'
import { MessageBox, Loading } from 'element-ui'
// import { getToken, removeToken } from './auth'
// import * as types from "../../../store/mutation-types"

// 创建一个axios实例
const instance = axios.create() // { timeout: 3000 }

// 白名单（不加loading效果）
let whiteList = [
  '/logisticsTrackings/search'
]
// http request 拦截器
// let accesssToke = 'Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IkJFQ0M4NUNBOTc1MDEyQTZERUMzNzk2MzczODBBN0ZGQUZGMjkzMEMiLCJ0eXAiOiJKV1QiLCJ4NXQiOiJ2c3lGeXBkUUVxYmV3M2xqYzRDbl82X3lrd3cifQ.eyJuYmYiOjE1Mzk5MTk1NTUsImV4cCI6MTUzOTkyMzE1NSwiaXNzIjoiaHR0cHM6Ly9hdXRoLmdsb2JhbHBjZi5uZXQiLCJhdWQiOlsiaHR0cHM6Ly9hdXRoLmdsb2JhbHBjZi5uZXQvcmVzb3VyY2VzIiwidGVuYW50SWRlbnRpdHkiLCJmaWxlVXBsb2FkIiwidmF0Q2xpZW50IiwidHJhY2tpbmdZZWVTZXJ2aWNlIiwiUGxhdGZvcm1TaG9wIiwidHJhZGVNYXJrUmVnaXN0cmF0aW9uIl0sImNsaWVudF9pZCI6InNhYXMtanMtY2xpZW50Iiwic3ViIjoiODkxZGNmY2ItNjFmMi00NmNjLWEwNmYtMmZlZDMxN2NkMzE0IiwiYXV0aF90aW1lIjoxNTM5OTE1MzY3LCJpZHAiOiJsb2NhbCIsInByZWZlcnJlZF91c2VybmFtZSI6Imxlby5odWFuZ2xpYW5nMjAxNUBnbWFpbC5jb20iLCJ1bmlxdWVfbmFtZSI6Imxlby5odWFuZ2xpYW5nMjAxNUBnbWFpbC5jb20iLCJ0ZW5hbnRjb2RlIjoic2FhczAxIiwidGVuYW50bmFtZSI6IiIsImZ1bGxfbmFtZSI6IuS6ruWTpSIsInJvbGUiOiJUZW5hbnRPd25lciIsImVtYWlsIjoibGVvLmh1YW5nbGlhbmcyMDE1QGdtYWlsLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJwaG9uZV9udW1iZXIiOiIxODMzMjU1NTQ4NCIsInBob25lX251bWJlcl92ZXJpZmllZCI6dHJ1ZSwic2NvcGUiOlsib3BlbmlkIiwicHJvZmlsZSIsInRlbmFudElkZW50aXR5IiwiZmlsZVVwbG9hZCIsInZhdENsaWVudCIsInRyYWNraW5nWWVlU2VydmljZSIsIlBsYXRmb3JtU2hvcCIsInRyYWRlTWFya1JlZ2lzdHJhdGlvbiJdLCJhbXIiOlsicHdkIl19.ZlbkEzBX_yZq0qoXFhBtbxRFNhXnQPhHSzjq_GSJs4z8txo2T0Z7Q-Wbz3rOJXOv7WrIOBvLOekbmfbkbBIrG8G_cHI5XrMXE8MPUFAD13dEOBpcJqQ5dIYZLkrTwHiSNXpA1_QN6HK46T8jcfDJvNFcApOiAI-a_9PWlqutIq7t2CUhdYYGLMtFMb91AwQ43B_5h2knWKj4clSuffh7TjiEwGaH55SchJyRFuAdxRLNSvmC5bAbMhfM9d6DWm1dL3ZIXqbQr0J54duIg397yRhXDZAPm9v7NAIoEn7Ghxi6ElnaoFXsLtvonIP5fXGR0-LTYn6MLjDT-KEx68lrEQ'
instance.interceptors.request.use(

  config => {
    // 在请求发出之前进行一些操作
    // Loading.service({ fullscreen: true, text: '正在请求' })
    // let blackBool = true // 默认使用loading
    // // loading 关闭
    // Loading.service().close()

    // // 白名单不加loading效果
    // for (var i = 0; i < whiteList.length; i++) {
    //   if (config.url.toLocaleLowerCase().indexOf(whiteList[i].toLocaleLowerCase()) != -1) {
    //     blackBool = false
    //     break
    //   }
    // }
    // console.log(blackBool)
    // if (blackBool) {
    //   // loading 开始
    //   Loading.service({ fullscreen: true, text: '正在请求' })
    // }
    // if (!whiteList.includes(config.url)) {
    //   Loading.service({ fullscreen: true, text: '正在请求' })
    // }

    // if (!localStorage['accessToken']) {
    //   // 没有用户标识  即需要用户去登陆
    //   if (window.parent.login401) {
    //     // 调用父级方法登录
    //     // console.log(window.parent)
    //     window.parent.login401()
    //   }
    // } else {
    //   config.headers['authorization'] = 'Bearer ' + localStorage['accessToken']
    //   // 有用户标识 则将用户标识符设置为请求头
    // }
    // config.headers['authorization'] = accesssToke
    return config
  },
  error => {
    MessageBox.alert(error, '接口请求错误', {
      confirmButtonText: '确定'
    })
    if (error) {
      return Promise.reject(error)
    }
  }
)
/**
 * http response 拦截器
 * resp.data.code:
 *    -10: 登录超时
 *    -1：登录无效
 *    0：成功，正常
 *    400：成功返回，需特殊处理
 */
instance.interceptors.response.use(
  resp => {
    // Loading.service().close()
    // 在这里对返回的数据进行处理
    if (resp.data.code === 403 || resp.data.code === 401) {
      // 后台返回登录超时   则置空缓存中的用户标识 并登录
      if (window.parent.login401) {
        // 调用父级方法登录
        // console.log(window.parent)
        window.parent.login401()
      }
    } else if (resp.data.code === 500) {
      // 后台返回400
      console.log('接口报错了')
      MessageBox.alert('接口请求错误，请联系管理员', '接口请求错误', {
        confirmButtonText: '确定'
      })
    }
    return Promise.resolve(resp)
  },
  error => {
    // Loading.service().close()
    console.log(`err: ${error}`)
    console.log('code', error.code)
    //  1.判断请求超时
    if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
      if (localStorage['timeoutUrl']) {
        let arr = JSON.parse(localStorage['timeoutUrl'])
        arr.push(error.config.url)
        let timeoutUrl = new Set(arr)
        localStorage['timeoutUrl'] = JSON.stringify(timeoutUrl)
      } else {
        let arr = []
        arr.push(error.config.url)
        localStorage['timeoutUrl'] = JSON.stringify(arr)
      }
      console.log('根据你设置的timeout请求超时 判断请求现在超时了，超时接口为：' + localStorage['timeoutUrl'])
      MessageBox.confirm('您访问当前页面超时，请联系管理员', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        window.location.reload()
      }).catch(() => {
        window.location.reload()
      })
      // return axiosInstance.request(originalRequest);//例如再重复请求一次
    }
    if (error.response) {
      switch (error.response.status) {
        case 400:
          MessageBox.alert(error.response.data.Errors[0].Message, '接口请求错误', {
            confirmButtonText: '确定'
          })

          // console.log(error.response.data)
          // let errors = error.response.data.Errors[0].Message
          // let errorsItem = errors.split('：')
          // let textData = errorsItem[1].split('↵')
          // let text = ''
          // textData.map(function (item) {
          //   text = text + '<div>' + item + '</div>' + '<br>'
          // })
          // console.log(errorsItem)
          // MessageBox.alert(text, errorsItem[0], {
          //   confirmButtonText: '确定'
          // })
          // console.log(error.response.data.Errors)
          // if (error.response.data.Errors[0].Code === '800F1001') {
          //   MessageBox.alert('您上传的文件格式或类型错误，请参考模板文件上传', '上传的文件格式或类型错误', {
          //     confirmButtonText: '确定'
          //   })
          // }
          // if (error.response.data.Errors[0].Code === '800F1002') {
          //   MessageBox.alert(error.response.data.Errors[0].Message, '模板数据校验失败', {
          //     confirmButtonText: '确定'
          //   })
          // }
          // if (error.response.data.Errors[0].Code === '800F1003') {
          //   MessageBox.alert('导出订单数量不得超过100', '导入订单数量超出限制', {
          //     confirmButtonText: '确定'
          //   })
          // }
          // if (error.response.data.Errors[0].Code === '800F1004') {
          //   MessageBox.alert('请选择文件上传', '请选择文件上传', {
          //     confirmButtonText: '确定'
          //   })
          // }
          // if (error.response.data.Errors[0].Code === '800F1005') {
          //   MessageBox.alert('文件内容为空，请写入有效的订单信息', '文件内容不可为空', {
          //     confirmButtonText: '确定'
          //   })
          // }
          // if (error.response.data.Errors[0].Code === '800F1006') {
          //   MessageBox.alert('查找不到对应的订单', '查找不到对应的订单', {
          //     confirmButtonText: '确定'
          //   })
          // }
          break
        case 401:
          if (window.parent.login401) {
          // 调用父级方法登录
          // console.log(window.parent)
            MessageBox.confirm('您当前没有访问当前页面的权限，请联系管理员', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              window.parent.login401() // 调用父级方法登录
            }).catch(() => {
              window.parent.login401() // 调用父级方法登录
            })
          }
          break
        case 403:
          if (window.parent.login401) {
            // 调用父级方法登录
            // console.log(window.parent)
            MessageBox.confirm('您当前没有访问当前页面的权限，请联系管理员', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              window.parent.login401() // 调用父级方法登录
            }).catch(() => {
              window.parent.login401() // 调用父级方法登录
            })
          }
          break

        case 404:
          // MessageBox.alert('接口请求错误，请联系管理员', '接口请求错误', {
          //   confirmButtonText: '确定'
          // })
          window.parent.login404()
          break
        case 500:
          // MessageBox.alert('接口请求错误，请联系管理员', '接口请求错误', {
          //   confirmButtonText: '确定'
          // })
          // MessageBox.alert(error.response.data.Errors[0].Message, '接口请求错误', {
          //   confirmButtonText: '确定'
          // })
          console.log(error.response.data)
          window.parent.toError(error.response.data.Errors[0].Message)
      }
    }
    return Promise.reject(error)
  }
)

export default instance



// WEBPACK FOOTER //
// ./src/common/request.js